module.exports = __webpack_public_path__ + "static/img/72-3.395dfac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/72-3.jpg
// module id = qxcq
// module chunks = 0